import { Typography } from "@mui/material";

/**
 * Constructs a 'Typography' component with specific styling and properties.
 * @param {string} copy - The text for the 'Typography' component.
 * @param {boolean} [absolute=false] - If true, set the css position to 'absolute', otherwise set it to 'relative'.
 *
 * @returns {JSX.Element} A 'Typography' component with the passed text and specific styling.
 */
export default function OEMTableTitle(copy, absolute = false) {
	return (
		<Typography
			className={"!text-primary !font-montserrat pl-[10px] !text-[18px] !font-medium"}
			component="div"
			sx={{ position: absolute ? "absolute" : "relative" }}
		>
			{copy}
		</Typography>
	);
}
